let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ZmRu")).then(() => parcelRequire('bb8K8'));